export const products = [
  {
    id: 1,
    name: "Youth T-Shirt",
    description: "Premium youth cotton tee, hand-pressed with vibrant, long-lasting color. Perfect for the little royals.",
    price: 25.00,
    category: "apparel",
    image: "https://royal-ink-shop.lovable.app/assets/youth-tshirt-mockup-saRoexvv.png",
    customizable: true
  },
  {
    id: 2,
    name: "Short Sleeve T-Shirt",
    description: "Premium heavy-weight cotton tee, hand-pressed with vibrant, long-lasting color. A timeless essential.",
    price: 30.00,
    category: "apparel",
    image: "https://royal-ink-shop.lovable.app/assets/apparel-mockup-4-CHziElvo.png",
    customizable: true
  },
  {
    id: 3,
    name: "Long Sleeve T-Shirt",
    description: "Premium long sleeve tee, hand-pressed with vibrant, long-lasting color. Style meets comfort.",
    price: 35.00,
    category: "apparel",
    image: "https://royal-ink-shop.lovable.app/assets/long-sleeve-mockup-new-BUJGvX9C.png",
    customizable: true
  },
  {
    id: 4,
    name: "Crewneck Sweatshirt",
    description: "Premium heavy-weight crewneck, hand-pressed with vibrant, long-lasting color. Comfort meets style.",
    price: 45.00,
    category: "apparel",
    image: "https://royal-ink-shop.lovable.app/assets/crewneck-mockup-new-CxmQxDJ_.png",
    customizable: true
  }
];

export const categories = [
  {
    id: 1,
    name: "Royal Wear",
    description: "Exclusive signature collection",
    image: "https://royal-ink-shop.lovable.app/assets/emperor-hoodie-CGfXIoPu.png",
    slug: "royal-wear",
    icon: "crown"
  },
  {
    id: 2,
    name: "Apparel",
    description: "T-shirts, hoodies, polos & more",
    image: "https://royal-ink-shop.lovable.app/assets/apparel-mockup-1-CpSHoLEe.png",
    slug: "apparel",
    icon: "shirt"
  },
  {
    id: 3,
    name: "Drinkware",
    description: "Mugs, tumblers & cups with UVDTF",
    image: "https://royal-ink-shop.lovable.app/assets/uvdtf-mug-CKugI6ad.jpg",
    slug: "drinkware",
    icon: "coffee"
  },
  {
    id: 4,
    name: "Accessories",
    description: "Caps, bags, and lifestyle items",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=600&h=400&fit=crop",
    slug: "accessories",
    icon: "briefcase"
  },
  {
    id: 5,
    name: "Custom Orders",
    description: "Your vision, our expertise",
    image: "https://customer-assets.emergentagent.com/job_artisan-ink/artifacts/bhivj209_Gemini_Generated_Image_50jebd50jebd50je.png",
    slug: "custom",
    icon: "sparkles"
  }
];

export const navLinks = [
  { name: "Shop All", href: "/shop" },
  { name: "Apparel", href: "/shop?category=apparel" },
  { name: "Accessories", href: "/shop?category=accessories" },
  { name: "Bulk Orders", href: "/bulk-orders" },
  { name: "Policies", href: "/policies" }
];
